// Product form width handler
window.T4SThemeSP = window.T4SThemeSP || {};

T4SThemeSP.ProductFormWidth = (function () {
  function updateAddToCartWidth() {
    const formContainer = document.querySelector('.t4s-product__price-review');
    const mainProductAddToCart = document.querySelector('.main-product-add-to-cart');

    if (formContainer && mainProductAddToCart) {
      const formContainerWidth = formContainer.offsetWidth;
      // 120 is the size of .t4s-product-form__buttons .t4s-quantity-wrapper
      const adjustedWidth = formContainerWidth - 120;

      // show it 
      mainProductAddToCart.style.opacity = 1;
      // Handle responsive layout
      if (window.innerWidth > 768) {
        requestAnimationFrame(() => {
          mainProductAddToCart.style.width = `${adjustedWidth - 20}px`; // minus 20 for padding
          // mainProductAddToCart.style.right = `-${adjustedWidth}px`;
        });
      } else {
        mainProductAddToCart.style.position = 'relative';
        mainProductAddToCart.style.right = 'auto';
        requestAnimationFrame(() => {
          mainProductAddToCart.style.width = `${formContainerWidth}px`;
        });
      }
    }
    // on the mobile , click it once
    // 这是因为如是不这样做的话，第一次点击不会生效
    // if (window.innerWidth < 768) {
    //   const mini_cart=document.querySelector('.t4s-sticky-atc.is--shown')
    //   const visibility=window.getComputedStyle(mini_cart).visibility
    //   if(visibility=='hidden'){
    //     setTimeout(() => {
    //       mainProductAddToCart.click();
    //     }, 3000)
    //   }
    // }
  }

  function updateFrequentlyBoughtTogetherHeight() {
    // this is because the include with purchase is absolute, we need set the parent size manually
    const includeWithPurchase = document.querySelector('.include-with-purchase');
    console.log('updateFrequentlyBoughtTogetherHeight', includeWithPurchase)
    if (includeWithPurchase) {
      // 兼容性更好的是document.querySelectorAll('.t4s-container.t4s-main-product__content')
      // 不过暂时可以满足就行了。
      const frequentlyBoughtTogether = document.querySelector('.frequently-bought-together');
      if (frequentlyBoughtTogether) {
        // compare height with include with purchase,if purchase is higher than frequentlyBoughtTogether
        if (includeWithPurchase.offsetHeight > frequentlyBoughtTogether.offsetHeight) {
          frequentlyBoughtTogether.style.height = `${includeWithPurchase.offsetHeight}px`;
        }
      } else {
        const parent = includeWithPurchase.parentNode;
        console.log('updateFrequentlyBoughtTogetherHeight', parent.offsetWidth, includeWithPurchase.offsetHeight)
        parent.style.height = `${parent.offsetWidth + includeWithPurchase.offsetHeight + 100}px`;
      }
    }
  }



  // Add window resize listener with RAF for better performance
  let rafId;
  function handleResize() {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(updateAddToCartWidth);
  }

  // function handleAddToCart() {
  //   const addToCartButton = document.querySelector('.main-product-add-to-cart');
  //   if (addToCartButton) {
  //     addToCartButton.addEventListener('click', function (e) {
  //       console.log("here you click", e)
  //       e.preventDefault();
  //       // Find the closest form element
  //       // document.querySelector('.t4s-sticky-atc__atc.t4s-btn-loading__svg').click()
  //       // this is because on the mobile , you must click two times for real commit
  //       let proudctShow = document.querySelector('.t4s-sticky-atc__product')
  //       if (proudctShow.style.display === 'none' || proudctShow.style.display === '') {
  //         document.querySelector('.t4s-sticky-atc__atc.t4s-btn-loading__svg').click()
  //       }
  //     });
  //   }
  // }

  function initHooks() {
    updateAddToCartWidth();
    // handleAddToCart();
    // updateFrequentlyBoughtTogetherHeight();
  }

  function init() {
    // Initial setup
    document.addEventListener('DOMContentLoaded', initHooks);

    // Shopify specific events
    document.addEventListener('shopify:section:load', initHooks);
    document.addEventListener('shopify:block:select', initHooks);

    // Window resize
    window.addEventListener('resize', handleResize);

    // Run immediately if DOM is already loaded
    if (document.readyState === 'complete') {
      initHooks();
    }
  }

  return {
    init: init,
  };
})();

// Initialize the module
T4SThemeSP.ProductFormWidth.init();
